import { createContext, useContext } from "react";

export interface VerificationLauncherContextValue {
  startVerification: (userId: string, deviceId: string) => Promise<void>;
}

const VerificationLauncherContext = createContext<VerificationLauncherContextValue | null>(null);

export function VerificationLauncherProvider({
  value,
  children,
}: {
  value: VerificationLauncherContextValue;
  children: React.ReactNode;
}) {
  return (
    <VerificationLauncherContext.Provider value={value}>
      {children}
    </VerificationLauncherContext.Provider>
  );
}

export function useVerificationLauncher(): VerificationLauncherContextValue {
  const value = useContext(VerificationLauncherContext);
  if (!value)
    throw new Error("useVerificationLauncher must be used inside VerificationLauncherProvider");
  return value;
}

export function useOptionalVerificationLauncher(): VerificationLauncherContextValue | null {
  return useContext(VerificationLauncherContext);
}
